export default __webpack_public_path__ + "static/media/img-0110-canada-full-face.848ffd34.png";